<template>
  <div v-if="isVisible" class="b-modal-overlay" @click.self="closeModal">
    <div class="b-modal-content bg-white p-4 rounded shadow-lg">
      <div class="d-flex justify-content-between align-items-start mb-3">
        <h3 class="text-danger font-weight-bold mb-0">⚠️ Saldo Bajo Detectado</h3>
        <button type="button" class="close" @click="closeModal">&times;</button>
      </div>

      <p class="mb-3">
        Su saldo actual es de **{{ formattedBalance }} MXN**.
      </p>
      <p class="small text-muted">
        Le recomendamos recargar su monedero pronto para evitar la interrupción de sus servicios de envío.
      </p>

      <div class="d-flex justify-content-end mt-4">
        <button type="button" class="btn btn-outline-secondary mr-2" @click="closeModal">Cerrar</button>
        <router-link to="/prepaids" class="btn btn-primary" @click.native="closeModal">
          Recargar Ahora
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LowBalanceModal',
  props: {
    // Controla si el modal debe mostrarse
    isVisible: {
      type: Boolean,
      required: true,
    },
    // El valor del saldo actual
    currentBalance: {
      type: [Number, String],
      default: 0,
    },
  },
  computed: {
    formattedBalance() {
      // Función para formatear el saldo (la copiamos de tu Sidebar.vue)
      return Number(this.currentBalance).toLocaleString("es-MX", { style: "currency", currency: "MXN" });
    }
  },
  methods: {
    closeModal() {
      // Emitimos un evento para que el componente padre (Sidebar) lo escuche y oculte el modal
      this.$emit('close');
    }
  }
};
</script>

<style scoped>
/* Estilos básicos para el modal */
.b-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  /* Fondo semitransparente */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1050;
  /* Asegura que esté por encima de otros elementos */
}

.b-modal-content {
  max-width: 450px;
  width: 90%;
}

.close {
  font-size: 1.5rem;
  line-height: 1;
  color: #000;
  opacity: 0.5;
  border: none;
  background: transparent;
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/LowBalanceModal.vue